import { useHistory, useLocation } from "react-router-dom";
import { Link, LinkProps } from "@mui/material";

import { IAssignedUser } from "types/user";

export const DetailLink = ({
  userInfo,
  children,
  ...otherProps
}: LinkProps<"button"> & { userInfo: IAssignedUser }) => {
  const history = useHistory();
  const { pathname } = useLocation();

  return (
    <Link
      component="button"
      onClick={() => history.push(`${pathname}/${userInfo.id}`, userInfo)}
      {...otherProps}
    >
      {children}
    </Link>
  );
};
